import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import Logo from "./Logo"

import './Footer.scss'

const IconMail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12">
    <path d="M5.125,20A1.153,1.153,0,0,1,4,18.875V9.125A1.153,1.153,0,0,1,5.125,8h12.75A1.153,1.153,0,0,1,19,9.125v9.75A1.153,1.153,0,0,1,17.875,20ZM11.5,14.338,5.125,10.156v8.719h12.75V10.156Zm0-1.125,6.3-4.088H5.219ZM5.125,10.156v0Z" transform="translate(-4 -8)" />
  </svg>
)

const IconPhone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    <path d="M20.063,21a11.238,11.238,0,0,1-5.052-1.25,17.339,17.339,0,0,1-7.76-7.76A11.238,11.238,0,0,1,6,6.938.925.925,0,0,1,6.938,6H9.854a.737.737,0,0,1,.51.2.921.921,0,0,1,.281.531l.563,2.625a1.5,1.5,0,0,1-.01.531.8.8,0,0,1-.219.406L8.9,12.4a17.3,17.3,0,0,0,2.615,3.375,14.45,14.45,0,0,0,3.281,2.437l1.979-2.042a1.152,1.152,0,0,1,.479-.323.963.963,0,0,1,.542-.031l2.479.542a.91.91,0,0,1,.729.9v2.813a.925.925,0,0,1-.937.938ZM8.271,11.25,9.958,9.542,9.479,7.25H7.25A7.171,7.171,0,0,0,7.5,9.031a16.793,16.793,0,0,0,.771,2.219Zm7.687,7.563a10.4,10.4,0,0,0,1.854.646,9.777,9.777,0,0,0,1.938.292V17.521L17.6,17.083ZM8.271,11.25ZM15.958,18.813Z" transform="translate(-6 -6)" />
  </svg>
)

const IconLocation = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10.8" height="16" viewBox="0 0 10.8 16">
    <path d="M15.9,15.64a15.79,15.79,0,0,0,3.14-3.23A5.208,5.208,0,0,0,20.1,9.52a4.14,4.14,0,0,0-1.49-3.34,4.008,4.008,0,0,0-1.37-.75A4.559,4.559,0,0,0,15.9,5.2a4.559,4.559,0,0,0-1.34.23,4.008,4.008,0,0,0-1.37.75A4.14,4.14,0,0,0,11.7,9.52a5.208,5.208,0,0,0,1.06,2.89A15.79,15.79,0,0,0,15.9,15.64Zm0,1.52a18.763,18.763,0,0,1-4.07-3.94,6.407,6.407,0,0,1-1.33-3.7,5.5,5.5,0,0,1,.49-2.39A5.419,5.419,0,0,1,12.26,5.4,5.308,5.308,0,0,1,14,4.35a5.332,5.332,0,0,1,3.8,0A5.308,5.308,0,0,1,19.54,5.4a5.418,5.418,0,0,1,1.27,1.73,5.5,5.5,0,0,1,.49,2.39,6.407,6.407,0,0,1-1.33,3.7A18.763,18.763,0,0,1,15.9,17.16Zm0-6.36a1.4,1.4,0,0,0,.99-2.39,1.4,1.4,0,0,0-1.98,1.98A1.349,1.349,0,0,0,15.9,10.8ZM10.5,20V18.8H21.3V20ZM15.9,9.52Z" transform="translate(-10.5 -4)" />
  </svg>
)

const ContactData = [
  {
    title: 'Contacto',
    content: [
      { type: 'mail', text: 'hola@derevo.com.mx' },
      { type: 'phone', text: '01 800 6384 470' },
      { type: 'mail', text: 'joinus@derevo.com.mx' }
    ]
  },
  {
    title: 'México',
    content: [
      { type: 'phone', text: '+52 (33) 47 37 27 97' },
      { type: 'location', text: 'Av. San Juan 1361, Ciudad Granja, 45010 Zapopan, Jalisco, México.' }
    ]
  },
  {
    title: 'Dallas Office',
    content: [
      { type: 'phone', text: '+469 430 7715 (Alan Rodriguez)' },
      { type: 'location', text: '7300 Windrose Ave.  Suite G300, Plano, Texas 75024.' }
    ]
  }
]

const SitemapData = [
  {
    title: 'Soporte',
    content: [
      { text: 'Levantar un ticket', link: '/support' }
    ]
  },
  {
    title: 'Soluciones',
    content: [
      { text: 'Data Creation', link: '/data-creation' },
      { text: 'Data Integration', link: '/data-integration' },
      { text: 'Data Analytics', link: '/data-analytics' },
      { text: 'Data Sharing', link: '/data-sharing' },
      { text: 'Data Culture', link: '/data-culture' }
    ]
  },
  {
    title: 'Careers',
    content: [
      { text: 'Únete al equipo', link: '/careers' },
      { text: 'Posiciones abiertas', link: 'https://derevo.bamboohr.com/jobs/', extrenal: true }
    ]
  },
  {
    title: 'Academy',
    content: [
      { text: 'Cursos de Qlik Sense', link: '/courses/qlik-sense' },
      { text: 'Cursos de Qlikview', link: '/courses/qlik-view' },
      { text: 'Cursos de Tableau', link: '/courses/tableau' },
      { text: 'Cursos de Data Science', link: '/courses/data-science' },
      { text: 'Blog', link: '/blog' },
    ]
  },
  {
    title: 'Tecnologías',
    content: [
      { text: 'Power BI', link: '/powerbi' },
      { text: 'Qlik', link: '/qlik' },
      { text: 'Tableau', link: '/tableau' },
      { text: 'Azure Synapse', link: '/azure-synapse' },
      { text: 'Snowflake', link: '/snowflake' },
      { text: 'Databricks', link: '/databricks' }
    ]
  }
]

class Footer extends React.Component {
  render() {
    return (
      <footer id="footer" className="footer">
        <div className="top">
          <div className="head">
            <div className="logo">
              <Logo />
            </div>
            <div className="badges">
              <StaticImage src="../images/microsoft-badge.png" width={65} height={65} alt="microsoft badge"/>
              <StaticImage src="../images/qlik-badge.png" width={150} height={37} alt="qlik badge"/>
            </div>
          </div>
          <div className="links">
            <div className="reviews"></div>
            <div className="social">
              <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/derevoanalytics/" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="65.234" height="65.234" viewBox="0 0 65.234 65.234"><path d="M219.486,213.243A6.243,6.243,0,1,1,213.243,207,6.243,6.243,0,0,1,219.486,213.243Zm0,0" transform="translate(-180.626 -180.626)" /><path d="M165.44,139.8a6.2,6.2,0,0,0-3.555-3.555,10.361,10.361,0,0,0-3.477-.645c-1.975-.09-2.568-.109-7.568-.109s-5.594.019-7.569.109a10.368,10.368,0,0,0-3.477.645,6.2,6.2,0,0,0-3.555,3.555,10.366,10.366,0,0,0-.645,3.478c-.09,1.975-.109,2.567-.109,7.569s.019,5.593.109,7.569a10.363,10.363,0,0,0,.645,3.477,6.2,6.2,0,0,0,3.555,3.555,10.35,10.35,0,0,0,3.478.645c1.975.09,2.567.109,7.568.109s5.594-.019,7.569-.109a10.35,10.35,0,0,0,3.478-.645,6.2,6.2,0,0,0,3.555-3.555,10.372,10.372,0,0,0,.645-3.477c.09-1.975.109-2.568.109-7.569s-.019-5.594-.109-7.569A10.35,10.35,0,0,0,165.44,139.8Zm-14.6,20.663a9.618,9.618,0,1,1,9.618-9.618A9.618,9.618,0,0,1,150.839,160.46Zm10-17.368a2.248,2.248,0,1,1,2.248-2.248A2.248,2.248,0,0,1,160.837,143.093Zm0,0" transform="translate(-118.222 -118.226)" /><path d="M32.617,0A32.617,32.617,0,1,0,65.234,32.617,32.621,32.621,0,0,0,32.617,0ZM51.234,40.339a13.741,13.741,0,0,1-.87,4.546,9.577,9.577,0,0,1-5.478,5.478,13.751,13.751,0,0,1-4.546.87c-2,.091-2.635.113-7.722.113s-5.725-.022-7.722-.113a13.751,13.751,0,0,1-4.546-.87,9.577,9.577,0,0,1-5.478-5.478A13.738,13.738,0,0,1,14,40.339c-.092-2-.113-2.636-.113-7.722s.021-5.725.113-7.722a13.743,13.743,0,0,1,.87-4.546,9.583,9.583,0,0,1,5.478-5.478A13.754,13.754,0,0,1,24.9,14c2-.091,2.635-.113,7.722-.113s5.725.022,7.722.113a13.757,13.757,0,0,1,4.546.869,9.579,9.579,0,0,1,5.478,5.478,13.74,13.74,0,0,1,.871,4.546c.091,2,.112,2.635.112,7.722S51.325,38.342,51.234,40.339Zm0,0" /></svg>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UC9Ops_0nroENhxIBugg0Ukg" aria-label="Youtube">
                <svg xmlns="http://www.w3.org/2000/svg" width="41.088" height="41.088" viewBox="0 0 41.088 41.088"><path d="M224.113,215.737l6.683-3.849-6.683-3.849Zm0,0" transform="translate(-206.128 -191.344)" /><path d="M20.544,0A20.544,20.544,0,1,0,41.088,20.544,20.546,20.546,0,0,0,20.544,0ZM33.381,20.565a33.907,33.907,0,0,1-.529,6.175A3.217,3.217,0,0,1,30.589,29c-2.009.529-10.045.529-10.045.529s-8.015,0-10.045-.55a3.217,3.217,0,0,1-2.263-2.263,33.758,33.758,0,0,1-.529-6.175,33.885,33.885,0,0,1,.529-6.175A3.282,3.282,0,0,1,10.5,12.085c2.009-.529,10.045-.529,10.045-.529s8.036,0,10.045.55a3.217,3.217,0,0,1,2.263,2.263,32.177,32.177,0,0,1,.529,6.2Zm0,0" /></svg>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/Derevo_QV" aria-label="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" width="40.578" height="40.578" viewBox="0 0 40.578 40.578"><path d="M20.289,0A20.289,20.289,0,1,0,40.578,20.289,20.291,20.291,0,0,0,20.289,0Zm9.264,15.819q.013.3.013.6a13.16,13.16,0,0,1-13.25,13.25h0a13.182,13.182,0,0,1-7.138-2.092,9.472,9.472,0,0,0,1.111.064,9.344,9.344,0,0,0,5.784-1.993,4.662,4.662,0,0,1-4.351-3.235,4.641,4.641,0,0,0,2.1-.08,4.658,4.658,0,0,1-3.736-4.565c0-.021,0-.04,0-.059a4.625,4.625,0,0,0,2.109.582,4.661,4.661,0,0,1-1.442-6.217,13.221,13.221,0,0,0,9.6,4.866A4.659,4.659,0,0,1,28.292,12.7a9.341,9.341,0,0,0,2.957-1.13A4.675,4.675,0,0,1,29.2,14.141a9.288,9.288,0,0,0,2.674-.733,9.464,9.464,0,0,1-2.323,2.412Zm0,0" /></svg>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/derevo/" aria-label="Linkedin">
                <svg xmlns="http://www.w3.org/2000/svg" width="40.34" height="40.34" viewBox="0 0 40.34 40.34"><path d="M858.5,386.388a20.17,20.17,0,1,1,20.168-20.119A20.172,20.172,0,0,1,858.5,386.388Zm1.266-10c0-.3,0-.553,0-.811.008-2.351-.022-4.7.037-7.053a2.342,2.342,0,0,1,2.661-2.6c1.453.019,2.155.84,2.215,2.6.008.24.005.48.005.72q0,3.2,0,6.406c0,.251.024.5.035.732h4.835a3.547,3.547,0,0,0,.046-.394c-.01-2.831.008-5.662-.055-8.492a9.791,9.791,0,0,0-.427-2.471A4.245,4.245,0,0,0,865.7,361.8c-2.224-.422-4.36-.379-5.962,1.932v-2.053h-4.907V376.39Zm-7.506.014V361.671H847.44V376.4Zm.048-19.747a2.459,2.459,0,0,0-2.47-2.457,2.433,2.433,0,0,0-2.448,2.473,2.489,2.489,0,0,0,2.459,2.478A2.528,2.528,0,0,0,852.3,356.657Z" transform="translate(-838.323 -346.048)" /></svg>
              </a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/Derevo.Expert.Services" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="40.103" height="40.103" viewBox="0 0 40.103 40.103"><path d="M291.358,508.668q-.251.041-.5.075Q291.108,508.709,291.358,508.668Zm0,0" transform="translate(-268.074 -468.826)" /><path d="M299.579,507.793l-.24.042Zm0,0" transform="translate(-275.893 -468.02)" /><path d="M278.2,510.34q-.293.033-.59.058Q277.906,510.373,278.2,510.34Zm0,0" transform="translate(-255.866 -470.367)" /><path d="M286.728,509.738l-.283.035Zm0,0" transform="translate(-264.01 -469.812)" /><path d="M306.876,506.41l-.212.044Zm0,0" transform="translate(-282.644 -466.745)" /><path d="M324.655,502.113l-.171.047Zm0,0" transform="translate(-299.069 -462.785)" /><path d="M319.245,503.543l-.186.048Zm0,0" transform="translate(-294.068 -464.103)" /><path d="M312.264,505.254l-.2.044Zm0,0" transform="translate(-287.624 -465.68)" /><path d="M273.8,511.09l-.317.024Zm0,0" transform="translate(-252.06 -471.059)" /><path d="M40.1,20.051A20.051,20.051,0,1,0,20.051,40.1c.118,0,.235,0,.352,0V24.489H16.1v-5.02H20.4V15.774c0-4.285,2.616-6.617,6.438-6.617a35.462,35.462,0,0,1,3.862.2v4.478H28.068c-2.079,0-2.482.988-2.482,2.438v3.2h4.972l-.648,5.02H25.586V39.328A20.062,20.062,0,0,0,40.1,20.051Zm0,0" /><path d="M265.519,511.43q-.313.02-.628.031Q265.206,511.451,265.519,511.43Zm0,0" transform="translate(-244.143 -471.372)" /><path d="M260.837,511.836l-.333.008Zm0,0" transform="translate(-240.1 -471.746)" /></svg>
              </a>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="footer-information">
            <div className="info">
              {
                ContactData.map(i => (
                  <div className="card" key={i.title}>
                    <div className="title">
                      <span>{i.title}</span>
                    </div>
                    <div className="description">
                      {
                        i.content.map(ii => (
                          <div className={`item ${ii.type}`} key={ii.text}>
                            <span className="icon">
                              {ii.type === "mail" ? <IconMail /> : ii.type === "phone" ? <IconPhone /> : <IconLocation />}
                            </span>
                            <span className="text">{ii.text}</span>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                ))
              }
            </div>
            <div className="sitemap">
              {
                SitemapData.map(i => (
                  <div className="site-section" key={i.title}>
                    <div className="title">
                      <span>{i.title}</span>
                    </div>
                    <ul className="list">
                      {
                        i.content.map(ii => (
                          <li className="item" key={ii.text}>
                            {
                              ii.extrenal ?
                                <a href={ii.link}>{ii.text}</a>
                                :
                                <Link to={ii.link}>{ii.text}</Link>
                            }
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
        <div className="legal">
          <span>2020 Derevo ©</span>
          <Link to="/terms">Notice of confidentiality</Link>
        </div>
      </footer>
    )
  }
}

export default Footer